/* eslint-disable react/no-danger */
import React from 'react';
import Box from 'core/ui/Box';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';

const TypeDescription = ({ itemMessage }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-2">
        <Tooltip title={t(`label.help.contactForm.type.${itemMessage?.ownerableType}`)}>
          <Info fontSize="small" className="tw-text-gray-600" />
        </Tooltip>
        {itemMessage?.ownerableType === 'ContactForm' && <div>{t('label.contact')}</div>}
        {itemMessage?.ownerableType === 'AutomationWorkflowsTypesExecution' && (
          <div>
            {t('label.automationWorkflow')}&nbsp;
            {itemMessage?.ownerable?.workflowsType?.workflowName}&nbsp;/&nbsp;
            {itemMessage?.ownerable?.workflowsType?.name}
          </div>
        )}
        {itemMessage?.ownerableType === 'Channel' && <div>{t('label.message')}</div>}
      </div>
    </Box>
  );
};

export default TypeDescription;
